import { render, staticRenderFns } from "./GlossaryIndex.vue?vue&type=template&id=9a685efc&"
import script from "./GlossaryIndex.vue?vue&type=script&lang=js&"
export * from "./GlossaryIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a685efc')) {
      api.createRecord('9a685efc', component.options)
    } else {
      api.reload('9a685efc', component.options)
    }
    module.hot.accept("./GlossaryIndex.vue?vue&type=template&id=9a685efc&", function () {
      api.rerender('9a685efc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/glossary/GlossaryIndex.vue"
export default component.exports